import { ele } from "cables-shared-client";
import web from "./index.js";
import api from "./api.js";

export default class ActivityFeed
{
    constructor()
    {
        document.addEventListener("visibilitychange", () =>
        {
            if (document.visibilityState === "visible")
            {
                this.updateNavIcon();
            }
        });

        this.registerActionListeners(document);
        this.updateNavIcon();
    }

    updateNavIcon()
    {
        const feedIcon = ele.byId("nav-bar-activityfeed-wrapper");
        if (feedIcon)
        {
            api.get("activityfeed/myfeedcount", (res) =>
            {
                const data = res.data;
                const actionable = feedIcon.querySelector(".redbubble");
                const unread = feedIcon.querySelector(".dot");
                const important = feedIcon.querySelector(".important");
                if (data.action_required)
                {
                    ele.hide(unread);
                    ele.hide(important);
                    actionable.innerText = data.action_required;
                    ele.show(actionable);
                }
                else if (data.important)
                {
                    ele.show(important);
                    ele.hide(actionable);
                }
                else if (data.unread)
                {
                    ele.hide(actionable);
                    ele.hide(important);
                    ele.show(unread);
                }
                else
                {
                    ele.hide(unread);
                    ele.hide(important);
                    ele.hide(actionable);
                }
            });
        }
    }

    registerActionListeners(scopeEl)
    {
        const allActions = scopeEl.querySelectorAll(".feedaction");
        allActions.forEach((feedaction) =>
        {
            feedaction.addEventListener("click", () =>
            {
                const topic = feedaction.dataset.topic;
                const delegateId = feedaction.dataset.delegateId;
                const action = feedaction.dataset.action;
                if (action !== "delete_entry") web.buttons.startSavingAnimButton(feedaction);
                api.post("activityfeed/" + topic + "/" + delegateId + "/" + action, {}, (res) =>
                {
                    if (action !== "delete_entry")
                    {
                        web.buttons.stopSavingAnimButton(feedaction, true);
                        window.location.reload();
                    }
                    ele.hide(feedaction.closest(".activityFeedEntry"));
                }, (e) =>
                {
                    if (action !== "delete_entry") web.buttons.stopSavingAnimButton(feedaction, false);
                });
            });
        });
    }
}
